import { Directive, ElementRef, Inject, Input, NgZone, Optional } from "@angular/core";
import { ANIMATION_MODULE_TYPE } from "@angular/platform-browser/animations";
import { ɵNzTabsInkBarDirective } from "ng-zorro-antd/tabs";
import { UiTabPositionMode } from "../models/tab.models";

@Directive({
  selector: "ui-tabs-ink-bar, [ui-tabs-ink-bar]",
  host: {
    class: "ui-tabs-ink-bar",
    "[class.ui-tabs-ink-bar-animated]": "_animated",
  },
})
export class UiTabsInkBarDirective extends ɵNzTabsInkBarDirective {
  @Input() public position: UiTabPositionMode = "horizontal";
  @Input() public animated = true;

  constructor(elementRef: ElementRef<HTMLElement>, ngZone: NgZone, @Optional() @Inject(ANIMATION_MODULE_TYPE) public animationMode?: string) {
    super(elementRef, ngZone, animationMode);

    this.element = elementRef;
  }

  private element: ElementRef<HTMLElement>;
  private horizontalOffsetFromEachSide = 4;

  public setStyles(element: HTMLElement): void {
    super.setStyles(element);

    if (this.position === "horizontal") {
      this.overrideHorizontalWidth(element);
      this.overrideHorizontalLeft(element);
    }
  }

  private overrideHorizontalWidth(element: HTMLElement): void {
    const inkBar: HTMLElement = this.element.nativeElement;
    const offsetWidth = element.offsetWidth || 0;
    const targetWidth = offsetWidth - 2 * this.horizontalOffsetFromEachSide;

    inkBar.style.width = `${targetWidth}px`;
  }

  private overrideHorizontalLeft(element: HTMLElement): void {
    const inkBar: HTMLElement = this.element.nativeElement;
    const offsetLeft = element.offsetLeft || 0;
    const targetLeft = offsetLeft + this.horizontalOffsetFromEachSide;

    inkBar.style.left = `${targetLeft}px`;
  }
}
